import type { FeedEvent } from "@/types/feed";

export const FEED_PAGE_SIZE = 20;

/**
 * Project the in-memory page onto the current query. When filters change, the
 * previous page is hidden immediately so the list can show a loading state
 * until the matching response arrives — unless a warm cache already has the
 * next page, in which case we paint it on this render and skip the skeleton.
 */
export function resolveCursorFeedPage<T>(
  events: T[],
  loadedParamsKey: string | null,
  paramsKey: string,
  loading: boolean,
  warmEvents?: T[] | null,
): { events: T[]; loading: boolean } {
  const aligned = loadedParamsKey === paramsKey;
  if (aligned) {
    return { events, loading };
  }
  if (warmEvents != null) {
    return { events: warmEvents, loading: false };
  }
  return { events: [], loading: true };
}

/** Append `incoming` to `existing`, dropping any events already present by id. */
export function mergeFeedPages(
  existing: FeedEvent[],
  incoming: FeedEvent[],
): FeedEvent[] {
  const seen = new Set(existing.map((e) => e.id));
  const fresh = incoming.filter((e) => !seen.has(e.id));
  return fresh.length === 0 ? existing : [...existing, ...fresh];
}
